/**
 * Пример использования:
 *
 * <cat-datepicker
 watcher="{{watcher}}"
 cat-toogle-dropdown="{{toggle}}"
 cat-scroll-page="{{scrollPage}}"
 cat-scroll-type="{{scrollType}}"
 cat-set-period="{{setPeriod}}"
 cat-clear-input="{{clearInput}}">
 </cat-datepicker>
 *
 * {{watcher}}
 * calendars - массив объектов с месяцами или днями
 * availableRange - период доступный для выбора в дейтпикере
 * range - выбранный период в дейтпикере
 * title - отформатированные выбранные даты которые отображаються в главном инпуте дейтпикера
 * isOpen - параметр опеределяющий состояние дейтпикера (Открыт/Закрыт)
 * [isDisabled] - параметр опеределяющий состояние дейтпикера (Включен/Отключен)
 * [withInputs] - параметр отвечающий за вывод инпутов с выбранным периодом и возможностью руками вводить даты
 * [selectorDates] - связанный параметр с withInputs в нем содержаться отформатированные выбранные даты для вывода
 *                   в инпуты которые в находятся в раскрытом дейтпикере
 * [mod] - количество одновременно отображаемых календарей в дейтпикере,
 *         по умолчанию один (threedatepickers / twodatepickers )
 * [withoutButton] - убрать кнопку "Выбрать"
 * [id] - id календаря
 * [selectedDate] - текущая выбранная дата в календаре (при варианте когда нельзя выбрать период)
 * [selectDateSignal] - сигнал когда была выбрана одна дата в календаре
 *
 * {{toggle}}
 * Сигнал который вызываеться при нажатии открытии дейтпикера
 *
 * {{scrollPage}}
 * Сигнал который вызываеться при перелистывании календаря
 *
 * {{scrollType}}
 * Параметр отвечающий за тип шага перелистывания календаря (месяц/год)
 *
 * {{setPeriod}}
 * Сигнал который вызываеться при нажатии на кнопку выбрать
 *
 * {{clearInput}}
 * Сигнал который вызываеться при очистке инпута дейтпикера
 */
let css = require('./datepicker.css');
let $ = require('jquery');
let moment = require('moment');
let _ = require('lodash');

const ARROW = `.${css.arrow}`;
const SELECT_BUTTON = `.${css.selectButton}`;
const APPEAR_BUTTON = `.${css.appearButton}`;
const CLEAR_BUTTON = `.${css.clearButton}`;
const CONTAINER = `.${css.container}`;
const PERIOD = `.${css.period}`;
const FROM = `.${css.from}`;
const TILL = `.${css.till}`;
const IS_OPEN = `.${css.isOpen}`;
const RIGHT = `.${css.right}`;
const ERROR = `.${css.error}`;

const Calendar = require('../calendar');

class Datepicker {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        this.initMaskedInput();

        return {
            click: {
                [ARROW]: this.changePage,
                [SELECT_BUTTON]: this.selectPeriod,
                [APPEAR_BUTTON]: this.toggleDropdown,
                [CLEAR_BUTTON]: this.clearInput,
                [CONTAINER]: this.stopPropagation
            },
            keyup: {
                [PERIOD + FROM]: _.partialRight(this.handleInput, 'from'),
                [PERIOD + TILL]: _.partialRight(this.handleInput, 'till')
            }
        };
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    toggleDropdown (e) {
        e.stopPropagation();

        let isParentFieldsSetDisabled = $(e.currentTarget).closest('fieldset').attr('disabled') === 'disabled';
        if (isParentFieldsSetDisabled) {
            return;
        }

        let datepickerBody = $(e.currentTarget);
        let dropdown = datepickerBody.next();
        let isOpen = !dropdown.hasClass(IS_OPEN.substring(1));

        let dropdownSignal = this.$context.props.toggleDropdown;
        let id = this.$context.attributes['id'];

        this.$context.signal(dropdownSignal, { id, isOpen });
    }

    changePage (e) {
        e.stopPropagation();

        let arrow = $(e.currentTarget);
        let toRight = arrow.hasClass(RIGHT.substring(1));

        let changePageSignal = this.$context.props.scrollPage;
        let type = this.$context.props.srollType;
        let id = this.$context.attributes['id'];

        this.$context.signal(changePageSignal, { id, toRight, type });
    }

    selectPeriod () {
        let periods = $(PERIOD);
        let fromVal = periods.filter(FROM).val();
        let tillVal = periods.filter(TILL).val();

        let format = 'DD.MM.YYYY';
        let from = moment(fromVal, format);
        let till = moment(tillVal, format);

        let period;

        if (from.isValid() && till.isValid()) {
            let date1 = from.unix();
            let date2 = till.unix();

            if (date1 > date2) {
                period = {
                    from: date2,
                    till: date1
                };
            } else {
                period = {
                    from: date1,
                    till: date2
                };
            }
        }

        let setPeriod = this.$context.props.setPeriod;

        this.$context.signal(setPeriod, { period });
    }

    clearInput (e) {
        e.preventDefault();

        let id = this.$context.attributes['id'];
        let clearInput = this.$context.props.clearInput;
        this.$context.signal(clearInput, { id });
    }

    stopPropagation (e) {
        e.stopPropagation();
    }

    initMaskedInput () {
        let element = this.$context.element;

        $(element).find(PERIOD).mask('99.99.9999');
    }

    handleInput (e) {
        let validate = this.$context.attributes['cat-validate'];

        if (validate) {
            return;
        }

        let $target = $(e.currentTarget);
        let $inputs = $(PERIOD);
        let $button = $(SELECT_BUTTON);
        let value = $target.val();

        let isFullDate = value.indexOf('_') === -1;
        let isValid = moment(value, 'DD.MM.YYYY').isValid();

        let isError = !(isFullDate && isValid);

        $target.toggleClass(ERROR.substring(1), isError);

        if ($inputs.hasClass(ERROR.substring(1))) {
            isError = true;
        }

        $button.toggleClass(ERROR.substring(1), isError);
    }
}

module.exports = {
    constructor: Datepicker,
    children: [
        {
            name: 'calendar',
            component: Calendar,
            parentPropsMap: {
                selectDate: 'selectDate'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./packages/account-ui/datepicker/index.js